import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgTungstenIcon from './svgs/TungstenIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var tungstenIcon = (props => useIcon(SvgTungstenIcon, SvgTungstenIcon, props));

export { tungstenIcon as default };
